import api from './api';

export const getLeaderboard = async () => {
  const response = await api({
    method: 'GET',
    url: '/voice-leaderboard-events',
  });
  return response;
};

export const getDetailLeaderboardEvent = async (eventId, limit) => {
  const response = await api({
    method: 'GET',
    url: `/voice-leaderboard-events/${eventId}/leaderboard`,
    params: {
      limit,
    },
  });
  return response;
};
